import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { sendLearnMoreInquiry } from '@/api/v4/content-items.api';
import { notify } from '@/ui/snackbar/notify';

export const useSendLearnMoreInquiry = () => {
  const { t } = useTranslation('feed', { keyPrefix: 'card' });

  const mutation = useMutation({
    mutationFn: sendLearnMoreInquiry,
    onSuccess: data => {
      notify({ message: data.alreadySent ? t`alreadySent` : t`inquirySent` });
    },
    onError: () => {
      notify({ message: t`inquiryError` });
    },
  });

  return {
    isPending: mutation.isPending,
    sendInquiry: mutation.mutateAsync,
  };
};
